// extracted by mini-css-extract-plugin
export var container = "_44-0";
export var error = "_44-9";
export var label = "_44-5";
export var light = "_44-6";
export var md = "_44-3";
export var sm = "_44-2";
export var thin = "_44-8";
export var thinBold = "_44-7";
export var vertical = "_44-4";
export var xs = "_44-1";